export default __webpack_public_path__ + "static/media/TitilliumWeb-Regular.e53e0538.ttf";